import { Alert, Button, Box, Typography, Avatar } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useUser } from '../contexts/UserContextNew'
import { StopCircle, Visibility } from '@mui/icons-material'

export default function MirroringBanner() {
  const { t } = useTranslation('team')
  const { userProfile, mirroredUser, setMirroredUser } = useUser()
  
  // Only show if admin is mirroring someone
  if (!mirroredUser || userProfile?.role !== 'school_admin' && userProfile?.role !== 'super_admin') {
    return null
  }

  const handleStopMirroring = () => {
    setMirroredUser(null)
  }

  return (
    <Alert 
      severity="warning" 
      sx={{ 
        borderRadius: 0,
        mb: 0,
        '& .MuiAlert-message': {
          width: '100%'
        }
      }}
      action={
        <Button 
          color="inherit" 
          size="small" 
          onClick={handleStopMirroring}
          startIcon={<StopCircle />}
          sx={{ fontWeight: 600 }}
        >
          {t('mirroringBanner.stopButton')}
        </Button>
      }
    >
      <Box display="flex" alignItems="center" gap={2}>
        <Visibility />
        <Avatar
          src={mirroredUser.photo_url || undefined}
          sx={{ width: 24, height: 24 }}
        >
          {mirroredUser.display_name?.[0]?.toUpperCase()}
        </Avatar>
        <Typography variant="body2" sx={{ fontWeight: 600 }}>
          {t('mirroringBanner.viewingAs', { name: mirroredUser.display_name || mirroredUser.email })}
        </Typography>
        <Typography variant="caption" color="text.secondary">
          ({mirroredUser.role})
        </Typography>
      </Box>
    </Alert>
  )
}